import { useEffect, useState } from "react"
import { fetchFotwItems } from "@/lib/tattooData"
import type { PortfolioItem } from "@/types/models"

export function useFotwFeed(fotwWeek: number) {
  const [items, setItems] = useState<PortfolioItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    setLoading(true)
    fetchFotwItems(fotwWeek)
      .then(setItems)
      .catch((err: unknown) => {
        console.error("Failed to load FOTW feed", err)
        setError(err)
      })
      .finally(() => setLoading(false))
  }, [fotwWeek])

  return { items, loading, error }
} 